const WidgetCheckbox = ({ checked, onChange, borderColor, onClick, size = "1.4rem" }) => {
  const outerSize = size;

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    } else {
      onChange(!checked);
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{
        width: outerSize,
        height: outerSize,
        borderRadius: "0.4rem",
        backgroundColor: checked ? "#BCC6FA" : "#FFFFFF66",
        border: borderColor ? `2px solid ${borderColor}` : "none",
        transition: "all 0.2s ease-in-out",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {checked && (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#333333E6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="5 13 9 17 19 7" />
        </svg>
      )}
    </div>
  );
};

export default WidgetCheckbox;
